module.exports = __webpack_public_path__ + "img/软件产品证书-智慧水利综合应用管理平台V1.0.ad00e9a7.jpg";